import React from 'react';

function PreferredTimeDisplay({ preferredTime }) {
  if (!preferredTime) return <span>No time specified</span>;

  const { dateRange, hourRange } = preferredTime;

  const formattedDateRange =
    dateRange?.from && dateRange?.to
      ? `${new Date(dateRange.from).toLocaleDateString()} – ${new Date(dateRange.to).toLocaleDateString()}`
      : 'No date range';

  const formattedHourRange =
    hourRange?.from && hourRange?.to
      ? `${hourRange.from} – ${hourRange.to}`
      : 'No hour range';

  return (
    <span>
      {formattedDateRange} | {formattedHourRange}
    </span>
  );
}

export default PreferredTimeDisplay;
